import React, { memo, useCallback, useState } from "react";

import { useTranslation } from "react-i18next";

import AddButton from "@components/buttons/AddButton";
import DotLoader from "@components/tailwindComponents/DotLoader";
import EmptyData from "@components/tailwindComponents/EmptyData";

import ModalFormationForm from "../components/modals/ModalFormationForm";
import Items from "./Items";

export default memo(function Index(props) {
  const { formations, isLoading, readOnly = false, isOnMyProfile = false } = props;
  const { t, i18n } = useTranslation("formation.formation");
  const [showModalFormationForm, setShowModalFormationForm] = useState(false);
  const [formationToEdit, setFormationToEdit] = useState();
  const toggleModalFormationForm = useCallback((formation) => {
    setShowModalFormationForm(
      (_showModalFormationForm) => !_showModalFormationForm
    );
    if (formation) {
      setFormationToEdit(formation);
    }
  }, [showModalFormationForm]);

  return (
    <>
      <div className="arh-flex arh-flex-col arh-pb-8 arh-pl-24 arh-pr-4">
        {!readOnly ? (
          <div className="arh-mb-8 arh-flex arh-items-center arh-space-x-8">
            <AddButton
              label={t("Ajouter une formation")}
              onClick={toggleModalFormationForm}
              color="arh-bg-greenColor hover:arh-bg-darkGreenColor"
            />
          </div>
        ) : (
          ""
        )}
        {!formations?.length ? (
          <EmptyData>
            {t("Aucune formation à afficher pour cet employé")}
          </EmptyData>
        ) : (
          <div className="arh-w-full">
            <table className="arh-w-full arh-table-fixed arh-font-poppins">
              <thead className="arh-sticky arh-top-0 arh-z-[5] arh-bg-greyColor">
                <tr className="arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-borderTable">
                  <th className="arh-w-[20%] arh-px-4 arh-py-3 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Titre formation")}
                  </th>
                  <th className="title_table_employer arh-w-[20%] arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Catégorie")}
                  </th>
                  <th className="title_table_employer arh-w-[15%] arh-truncate arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Date")}
                  </th>
                  <th className="title_table_employer arh-w-[15%] arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Heures")}
                  </th>
                  <th className="title_table_employer arh-w-[15%] arh-truncate arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Formateur")}
                  </th>
                  <th className="title_table_employer arh-w-[10%]  arh-truncate arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Note")}
                  </th>
                  <th className="arh-w-[19%] arh-truncate arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Fichier joint")}
                  </th>
                  <th className="arh-w-[19%] arh-truncate arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Coût total")}
                  </th>
                  <th className="title_table_employer arh-w-[20%] arh-truncate arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Admissibilité")}
                  </th>
                  <th className="arh-w-[10%] arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor">
                    {t("Statut")}
                  </th>
                  <th className="arh-w-[8%] arh-px-4 arh-py-3.5 arh-text-xs arh-font-semibold arh-capitalize arh-text-darkColor"></th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={11}>
                      <div className="arh-h-[20dvh]">
                        <DotLoader size="small" />
                      </div>
                    </td>
                  </tr>
                ) : formations.length > 0 ? (
                  formations.map((formation, index) => (
                    <React.Fragment key={formation?._id}>
                      <Items
                        key={formation?._id}
                        formation={formation}
                        t={t}
                        i18n={i18n}
                        toggleModalFormationForm={toggleModalFormationForm}
                        readOnly={readOnly}
                        isOnMyProfile={isOnMyProfile}
                      />
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={11}
                      className="arh-w-full arh-pb-8 arh-pt-8"
                    >
                      <EmptyData>
                        {t("Aucune formation à afficher pour cet employé")}
                      </EmptyData>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <ModalFormationForm
        show={showModalFormationForm}
        onClickClose={toggleModalFormationForm}
        formation={formationToEdit}
        isOnMyProfile={isOnMyProfile}
      />
    </>
  );
});
